import styled from 'styled-components';

const PayspotDetailsCard = styled.div`
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  ${({ w }) => w && `width: ${w}px;`}
  ${({ h }) => h && `height: ${h}px;`}
  overflow-y: auto;
  margin: 8px;
`;

const PayspotDetailsCardTitle = styled.h5`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  padding: 12px 8px;
  border-bottom: 1px solid #e5e5e5;
  margin: 0;
`;

export { PayspotDetailsCard, PayspotDetailsCardTitle };
